import a from "react";
import { getIconColor as c } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const r = {
  display: "block"
}, s = ({ size: e = 16, useVw: l, useRem: n, color: t, withColor: o, removeClassName: d, disableSSR: m, style: i, ...p }) => {
  const f = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "20px-anquanweishezhi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 20 20", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), className: d ? "" : "iconpark-icon", style: f, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "path",
    {
      fill: o ? c(t, 0, "#CC3D55") : "#CC3D55",
      datafollowfill: o ? c(t, 0, "#CC3D55") : "#CC3D55",
      d: "m9.362 17.347-2.748-1.52a6.023 6.023 0 0 1-3.108-5.271V5.37l5.992-2.468a1.318 1.318 0 0 1 1.004 0l5.992 2.468v5.185c0 2.191-1.19 4.21-3.107 5.27l-2.75 1.521c-.396.22-.878.22-1.275 0Zm2.005 1.318c-.85.47-1.883.47-2.734 0l-2.748-1.52A7.53 7.53 0 0 1 2 10.554V5.309c0-.572.345-1.088.874-1.306l6.05-2.491a2.824 2.824 0 0 1 2.151 0l6.05 2.491c.53.218.875.734.875 1.306v5.248a7.53 7.53 0 0 1-3.885 6.588l-2.748 1.52ZM8.147 7.157a.706.706 0 1 0-1 .998l1.855 1.854-1.854 1.854a.706.706 0 0 0 .998.998L10 11.008l1.854 1.853a.706.706 0 0 0 .998-.998l-1.854-1.854 1.854-1.854a.706.706 0 0 0-.998-.998L10 9.011 8.146 7.157Z",
      clipRule: "evenodd",
      fillRule: "evenodd"
    }
  )));
}, u = s;
export {
  u as default
};
